<template>
  <div>
    <div class="air__utils__heading">
      <div class="row">
        <div class="col-6 col-sm-8">
          <h5>Fees</h5>
        </div>
        <div class="col-6 col-sm-4 text-right">
          <add-fee v-if="pagepermission.insertable" @created="handleCreated"/>
        </div>
      </div>
    </div>
    <div class="row justify-content-center" v-if="pagepermission.viewable">
      <div class="col-xl-12">
        <div class="card">
          <div class="card-body">
            <fees-table :rolesetting="pagepermission" :data="data" :loading="loading" @updateTable="handleUpdateTable" />
          </div>
        </div>
        <div class="text-right">
          <a-pagination
              showSizeChanger
              @showSizeChange="onShowSizeChange"
              :total="meta.total"
              :pageSize.sync="pageSize"
              v-model="current"
              @change="onChange"
            >
          </a-pagination>
        </div>
      </div>
    </div>
    <div class="row justify-content-center" v-else>
      <p class="error">
        You don't have permission to use this feature.
      </p>
    </div>
  </div>
</template>

<script>
import FeesTable from '@/components/fee/Table/index'
import AddFee from '@/components/fee/Forms/Add/index'

export default {
  components: {
    FeesTable,
    AddFee,
  },
  beforeMount: function () {
    let rc = this.$roleutility.checkpermission('fee', 22)
    rc.then(data => {
      console.log('RoleCheck!Data processed. ', data)
      this.pagepermission = data.pagePermission
    })
  },
  mounted: function() {
    this.getPlans()
  },
  data: function() {
    return {
      loading: false,
      visible: false,
      data: [],
      meta: {},
      current: 1,
      pageSize: 30,
      pagepermission: {
        insertable: false,
        editable: false,
        viewable: false,
        deletable: false,
      },
    }
  },
  methods: {
    getPlans: function() {
      this.loading = true
      this.$http.get('/api/fee', {
        params: {
          limit: this.pageSize,
          page: this.current,
        },
      }).then(({ data }) => {
        this.loading = false
        this.data = data.data
        this.meta = data.meta
      })
    },
    handleCreated: function() {
      this.getPlans()
    },
    handleUpdateTable: function() {
      this.getPlans()
    },
    onShowSizeChange(current, pageSize) {
      this.pageSize = pageSize
      this.current = current
      this.getPlans()
    },
    onChange(current) {
      this.current = current
      this.getPlans()
    },
  },
}
</script>
